<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}
.lang-width {
  width: 450px !important;
}
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">家充无忧服务订单</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <button
          class="common-bg-button"
          @click="handleRefund()"
        >
          退 款
        </button>
        <button
          class="common-bg-button"
          @click="reset()"
        >
          重 置
        </button>
        <button
          class="common-bg-button"
          @click="getListData(pagination, true)"
        >
          搜 索
        </button>
        <button
          class="common-bg-button"
          @click="
            () => {
              showMultiQuerys = !showMultiQuerys;
            }
          "
        >
          高级筛选
        </button>
      </div>
      <!-- 高级筛选 -->
      <div
        class="multi-query-div el-fade-in-linear"
        v-if="showMultiQuerys"
      >
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">购买订单编号</p>
              <el-input
                clearable
                v-model="queryInfo.mapNo"
                size="small"
                placeholder="请输入购买订单编号"
              ></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">用户手机号</p>
              <el-input
                clearable
                v-model="queryInfo.custMobile"
                size="small"
                placeholder="请输入用户手机号"
              ></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">安装米数</p>
              <el-select
                size="small"
                v-model="queryInfo.cableInstallMeterType"
                placeholder="请选择安装米数"
                style="width: 100%"
              >
                <el-option
                  label="家充无忧服务10米"
                  value="TEN_METER"
                />
                <el-option
                  label="家充无忧服务20米"
                  value="TWENTY_METER"
                />
                <el-option
                  label="家充无忧服务30米"
                  value="THIRTY_METER"
                />
                <el-option
                  label="家充无忧服务40米"
                  value="FORTY_METER"
                />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">订单类型</p>
              <el-select
                size="small"
                v-model="queryInfo.walletListType"
                placeholder="请选择订单类型"
                style="width: 100%"
              >
                <el-option
                  label="买断"
                  value="ACTIVITY_PAYOUT"
                />
                <el-option
                  label="退出"
                  value="ACTIVITY_REFUND"
                />
                <el-option
                  label="违约"
                  value="ACTIVITY_DEFAULT"
                />
              </el-select>
            </el-col>
          </el-row>
          <el-row
            :gutter="20"
            class="margin-t-20"
          >
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">购买时间</p>
              <div class="flex-r">
                <el-date-picker
                  class="full-width"
                  size="small"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="paidTime"
                  @change="pickdate(paidTime)"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">退款方式</p>
              <el-select
                size="small"
                v-model="queryInfo.refundWay"
                placeholder="请选择订单类型"
                style="width: 100%"
              >
                <el-option
                  label="芝麻免押"
                  value="FREE"
                />
                <el-option
                  label="手动退款"
                  value="MANUAL"
                />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">退款原因</p>
              <el-select
                size="small"
                v-model="queryInfo.refundReason"
                placeholder="请选择订单类型"
                style="width: 100%"
              >
                <el-option
                  label="平台测算"
                  value="平台测算"
                />
                <el-option
                  label="用户申请"
                  value="用户申请"
                />
                <el-option
                  label="其他"
                  value="其他"
                />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">退款操作时间</p>
              <el-date-picker
                class="full-width"
                size="small"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="refundTime"
                @change="pickRefundDate(refundTime)"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>

    <!-- 退款弹窗 -->
    <el-dialog
      :title="popInfoText"
      :visible.sync="dialogVisible"
      width="30%"
      @close="handleClose('ruleForm')"
    >
      <div style="display: flex; flex-direction: column">
        <el-form
          :model="popFormInfo"
          :rules="popFromRules"
          ref="ruleForm"
          label-width="130px"
          class="demo-ruleForm"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="退款支付宝账户:">
                <el-input
                  v-model="popFormInfo.custMobile"
                  size="small"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="退款金额:">
                <el-input-number
                  v-model="popFormInfo.refundAmount"
                  size="small"
                  :min="0"
                  :max="popFormInfo.refundAmount ? popFormInfo.refundAmount : 0"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                label="退款类型:"
                prop="refundType"
              >
                <el-select
                  v-model="popFormInfo.refundType"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    label="全额退款"
                    value="ALL"
                  />
                  <el-option
                    label="部分退款"
                    value="PART"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                label="是否恢复服务使用:"
                prop="resetUse"
                label-width="180px"
              >
                <el-select
                  v-model="popFormInfo.resetUse"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    label="是"
                    value="Y"
                  />
                  <el-option
                    label="否"
                    value="N"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                label="退款原因:"
                prop="refundReason"
              >
                <el-select
                  v-model="popFormInfo.refundReason"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    label="平台测算"
                    value="平台测算"
                  />
                  <el-option
                    label="用户申请"
                    value="用户申请"
                  />
                  <el-option
                    label="其他"
                    value="其他"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              v-if="popFormInfo.refundReason == '其他'"
            >
              <el-form-item prop="refundRemark">
                <el-input
                  type="textarea"
                  v-model="popFormInfo.refundRemark"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div v-if="0">参与服务的免押订单暂不支持退款</div>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose('ruleForm')">取 消 </el-button>
        <el-button
          type="primary"
          @click="makeSure('ruleForm')"
          v-if="popFormInfo.cancelAmount"
          >确定退款</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      paidTime: [],
      refundTime: [],
      showMultiQuerys: false,
      operates: {
        width: 220,
        fixed: "right",
        list: [],
      }, // 列操作按钮

      dialogVisible: false,
      popInfoText: "",
      popFormInfo: {},
      popFromRules: {
        refundType: [
          { required: true, message: "请选择退款类型", trigger: "change" },
        ],
        resetUse: [
          {
            required: true,
            message: "请选择是否恢复服务使用",
            trigger: "change",
          },
        ],
        refundReason: [
          { required: true, message: "请选择退款原因", trigger: "change" },
        ],
        refundRemark: [
          { required: true, message: "请输入退款原因", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    //获取数据
    init() {
      this.getListData(this.pagination, true);
    },

    checkSelectOne() {
      let _ = this;
      if (_.selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (_.selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.post(_, _.$A.zeropay.orderList, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    //选择时间
    pickdate(time) {
      let _ = this;
      // 拆分时间区间
      _.queryInfo.createFromTime = time ? time[0] : "";
      _.queryInfo.createToTime = time ? time[1] : "";
    },
    pickRefundDate(time) {
      let _ = this;
      _.queryInfo.refundFromTime = time ? time[0] : "";
      _.queryInfo.refundToTime = time ? time[1] : "";
    },

    //重置
    reset() {
      delete this.queryInfo.mapNo;
      delete this.queryInfo.cableInstallMeterType;
      delete this.queryInfo.custMobile;
      delete this.queryInfo.walletListType;
      delete this.queryInfo.refundWay;
      delete this.queryInfo.refundReason;
      delete this.queryInfo.createFromTime;
      delete this.queryInfo.createToTime;
      delete this.queryInfo.refundFromTime;
      delete this.queryInfo.refundToTime;
      this.paidTime = [];
      this.refundTime = [];
      this.getListData(this.pagination, true);
    },

    // 退款操作
    handleRefund() {
      let _ = this;
      if (_.checkSelectOne()) {
        if (_.selections[0].refundResult == "Y") {
          this.$U.success("已成功退款");
          return;
        }
        if(_.selections[0].orderStatus == "TO_REFUND"){
           this.$U.success("退款中耐心等待");
          return
        }
        _.popInfoText = "退款金额确认";

        _.popFormInfo.custMobile = _.selections[0].custMobile;
        _.popFormInfo.mapNo = _.selections[0].mapNo;
        _.popFormInfo.cancelNo = _.selections[0].cancelNo;
        _.popFormInfo.refundAmount = _.selections[0].cancelAmount || 0;
        _.popFormInfo.custAccount = _.selections[0].custMobile || 0;
        _.popFormInfo.cancelAmount = _.selections[0].cancelAmount || 0;
        _.dialogVisible = true;
      }
    },
    makeSure(formName) {
      console.log("点击了退款");
      let _ = this;
      _.$refs[formName].validate((valid) => {
        if (valid) {
          _.$H
            .post(_, _.$A.zeropay.orderRefund, _.popFormInfo)
            .then((res) => {
              _.init();
              _.dialogVisible = false;
              this.$U.success("退款成功");
            })
            .catch((err) => {});
        }
      });
    },

    // 关闭 - 退款提示
    handleClose(formName) {
      let _ = this;
      _.$refs[formName].resetFields();
      _.dialogVisible = false;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
